import { Operation } from '../hooks/useOperations/types';
import { ALL_OPERATIONS } from './operations';

type ToggleOperationSelectionMode = {
  hasMultiOperationEnabled: boolean;
  operationsSelected: Operation[];
  operations: Operation[];
  setSelectedOperations: (opertaionsSelected: Operation[]) => void
}

export function toggleOperationSelectionMode({
  hasMultiOperationEnabled,
  operationsSelected,
  operations,
  setSelectedOperations,
}: ToggleOperationSelectionMode): void {
  const removeAllOperationsItem = ({ operationId }: { operationId: string }) => operationId !== ALL_OPERATIONS;

  const operationsWithOutAllObject = operations.filter(removeAllOperationsItem);

  const isAllOperationsObjectSelected = operationsSelected.length &&
    operationsSelected[0].operationId === ALL_OPERATIONS;

  const isMoreThanOneOperationSelectedForSingle = !hasMultiOperationEnabled &&
    operationsSelected.length > 1;

  if (isAllOperationsObjectSelected) {
    setSelectedOperations(operationsWithOutAllObject);
  } else if (isMoreThanOneOperationSelectedForSingle) {
    setSelectedOperations([operationsSelected[0]]);
  }
}
